import React, { useContext, useState } from 'react';
import { Container, Sidebar, Sidenav, Content, Nav, useMediaQuery} from 'rsuite';
import { Outlet } from 'react-router-dom';
import NavLink from '../NavLink';
import Brand from '../Brand';
import { RoleEnum } from '@/models/user.model';
import AppContext from '@/infra/AppContext';
import Header from '../Header';

export interface NavItemProps {
  eventKey: string;
  title: string;
  icon?: any;
  to: string;
  target?: string;
  children?: NavItemProps[];
  access?: RoleEnum[];
}

const NavItem = (props : NavItemProps) => {
  const { userData } = useContext(AppContext);
  // console.log(userData, isLoggedIn());
  if(props.access){
    const userRole = userData?.role;
    if(!props.access.some(r => r == userRole)){
      return <></>;
    }
  }

  if (props.children) {
    return (
      <Nav.Menu eventKey={props.eventKey} placement="rightStart" trigger="click" icon={props.icon} title={props.title}>
        {props.children.map(child => {
          return <NavItem key={child.eventKey} {...child} />;
        })}
      </Nav.Menu>
    );
  }
  
  if (props.target === '_blank') {
    return (
      <Nav.Item eventKey={props.eventKey} >
        {props.title}
      </Nav.Item>
    );
  }

  return (
    <Nav.Item eventKey={props.eventKey} to={props.to} as={NavLink} icon={props.icon} >
      {props.title}
    </Nav.Item>
  );
};


export interface FrameProps {
  navs: NavItemProps[];
  children?: React.ReactNode;
}

const Frame = (props: FrameProps) => {
  const { navs } = props;
  const [expand, setExpand] = useState(true);
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  const isExpanded = expand && !isMobile; 
  const { userData } = useContext(AppContext);
  return (
    <Container className="frame">
      <Sidebar h="100vh" width={isExpanded ? 260 : 56} collapsible>
        <Sidenav expanded={isExpanded} defaultOpenKeys={['3', '4']} h="100%">
          <Sidenav.Header>
            <Brand expanded={isExpanded} />
          </Sidenav.Header >
          <Sidenav.Body >
            <Nav>
              {navs.map(item => {
                return <NavItem key={item.eventKey} {...item} />;
              })}
            </Nav>
          </Sidenav.Body>
          <Sidenav.Footer>
            <Sidenav.Toggle onToggle={setExpand} />
          </Sidenav.Footer>          
        </Sidenav>
      </Sidebar>
      <Container className={`page-container ${!isExpanded ? 'container-full' : ''}`}>
        <Header profilePicture={userData?.profilePicture}/>
        <Content>
          <Outlet />
        </Content>
      </Container>
    </Container>
  );
};

export default Frame;